import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import Icon from 'uikit/Icon';
import Modal from 'uikit/Modal';
import Tooltip from 'uikit/Tooltip';

import styles from './ContentCreationMethod.module.scss';

const cx = classNames.bind(styles);

const ContentCreationMethod = ({
  handleMethodFromIA,
  handleMethodFromScratch,
  isOpen,
  t,
}) => (
  <Modal isOpen={isOpen} onExit={handleMethodFromScratch}>
    <div className={cx('modal')}>
      <div className={cx('header')}>
        <h1 className={cx('title')}>
          {t('Course/Teacher/ContentCreationMethod/title')}
        </h1>
        <Button
          aria-label={t('Course/Teacher/ContentCreationMethod/aria-close')}
          className={cx('close')}
          icon="times"
          onClick={handleMethodFromScratch}
        />
      </div>
      <div className={cx('choices')}>
        <button
          className={cx('choice', 'from-scratch')}
          data-testid="from-scratch-course-button"
          onClick={handleMethodFromScratch}
          type="button"
        >
          <Icon className={cx('icon')} name="plus" />
          <h2 className={cx('choice-title')}>
            {t('Course/Teacher/ContentCreationMethod/from-scratch-title')}
          </h2>
        </button>
        <button
          className={cx('choice', 'from-ia')}
          onClick={handleMethodFromIA}
          type="button"
        >
          <Tooltip
            tooltip={t('Course/Teacher/ContentCreationMethod/from-ia-tooltip')}
          >
            <Icon className={cx('tooltip-icon')} name="info-circle" />
          </Tooltip>
          <Icon className={cx('icon')} name="wand-sparkles" />
          <h2 className={cx('choice-title')}>
            {t('Course/Teacher/CourseMethod/from-ia-title')}
          </h2>
        </button>
      </div>
    </div>
  </Modal>
);

ContentCreationMethod.propTypes = {
  handleMethodFromIA: PropTypes.func.isRequired,
  handleMethodFromScratch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default ContentCreationMethod;
